import {Dispatch} from 'react';
import {authenticatedFetch, TokenNotFoundError} from './auth';
import {Conversation} from '../types';
import {getFriendlyErrorMessage} from './friendlyErrors';

const API_URL = import.meta.env.VITE_API_URL || '';

export async function pingApi(): Promise<boolean> {
    try {
        const res = await authenticatedFetch(`${API_URL}/api/ping`);
        return res.ok;
    } catch (e) {
        console.warn('pingApi failed', e);
        return false;
    }
}

export async function loadEventData(dispatch: Dispatch<any>, logout: () => void, options?: { silent?: boolean }) {
    const silent = options?.silent === true;
    if (!silent) dispatch({type: 'SET_LOADING', payload: true});
    try {
        const url = `${API_URL}/api/event`;
        const res = await authenticatedFetch(url);
        if (res.status === 401) {
            logout();
            if (!silent) {
                dispatch({
                    type: 'SET_ERROR',
                    payload: getFriendlyErrorMessage(new Error('Unauthorized')),
                });
            }
            dispatch({type: 'SET_ONLINE', payload: false});
            return;
        }
        if (!res.ok) {
            const err = await res.text();
            if (!silent) {
                dispatch({
                    type: 'SET_ERROR',
                    payload: getFriendlyErrorMessage(new Error(err || 'Failed to load event data'), {
                        genericMessage: 'Die Veranstaltungsdaten konnten gerade nicht geladen werden. Bitte versuchen Sie es erneut.',
                        participantMessage: 'Ihr Teilnehmerprofil konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
                    }),
                });
            }
            dispatch({type: 'SET_ONLINE', payload: false});
            return;
        }

        const data = await res.json();
        dispatch({type: 'SET_EVENT_DATA', payload: data});

        if (data.chat_conversations && Array.isArray(data.chat_conversations)) {
            dispatch({type: 'SET_CONVERSATIONS', payload: data.chat_conversations as Conversation[]});
        }

        const now = new Date().toISOString();
        dispatch({type: 'SET_LAST_UPDATED', payload: now});
        dispatch({type: 'SET_ONLINE', payload: true});
        if (!silent) {
            dispatch({type: 'SET_ERROR', payload: null});
        }
    } catch (e) {
        if (e instanceof TokenNotFoundError) {
            logout();
        }
        console.error('loadEventData error', e);
        if (!silent) {
            dispatch({
                type: 'SET_ERROR',
                payload: getFriendlyErrorMessage(e, {
                    genericMessage: 'Die Veranstaltungsdaten konnten gerade nicht geladen werden. Bitte versuchen Sie es erneut.',
                    participantMessage: 'Ihr Teilnehmerprofil konnte nicht geladen werden. Bitte versuchen Sie es später erneut.',
                }),
            });
        }
        dispatch({type: 'SET_ONLINE', payload: false});
        throw e;
    } finally {
        if (!silent) dispatch({type: 'SET_LOADING', payload: false});
    }
}
